import { defineSlotRecipe } from '@chakra-ui/react';
export const cardRecipe = defineSlotRecipe({
    className: 'card',
    slots: ['root', 'header', 'body', 'footer'],
    base: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            rounded: 'xl',
        },
        header: {
            display: 'flex',
            flexDirection: 'column',
            gap: { base: 2, md: 3 },
            p: { base: 3, md: 4 },
        },
        body: {
            display: 'flex',
            flexDirection: 'column',
            gap: { base: 4, md: 5 },
            p: { base: 4, md: 5 },
        },
        footer: {
            display: 'flex',
            flexDirection: 'column',
            gap: { base: 3, md: 4 },
            p: { base: 3, md: 4 },
        },
    },
    variants: {
        variant: {
            outline: {
                root: {
                    bg: 'cardBg',
                    borderWidth: '1px',
                    borderColor: 'cardBorder',
                },
            },
        },
    },
    defaultVariants: {
        variant: 'outline',
    },
});
